/* eslint-disable*/
import React, { Component } from "react";
import FormGroupNeeds from "./form/FormGroupNeeds";
import FormGroupNeedsMFA from "./form/FormGroupNeedsMFA";
import { connect } from "react-redux";
import {
  setIsCommValueChanged,
  setCommValue,
  setvalueCofirm
} from "../../actions/policy/policyActions";
import Store from "../../content/Store";
import {CommunicationPref} from "../../constants/Constants";

const mapDispatchToProps = (dispatch) => {
  return {
    setIsCommValueChanged: (Value) => dispatch(setIsCommValueChanged(Value)),
    setCommValue: (Value) => dispatch(setCommValue(Value)),
    setvalueCofirm: (Value) => dispatch(setvalueCofirm(Value))

  };
};
export const mapStateToProps = ({ preferenceConfirmReducer = {} }) => {
  return {
    prefval: preferenceConfirmReducer && preferenceConfirmReducer.PrefSelection
  };
};

export class SetCommunicationPreference extends Component {

  constructor(props) {
    super(props);
    this.state = {
      CommPreference: [],
      optionValue: false,
      PrefSecValue: true
    };
    this.PreferenceChanges = this.PreferenceChanges.bind(this);
    this.updatedValue = this.updatedValue.bind(this);
  }

  componentDidMount() {
    let updateCommPrefs = [];
    if (this.props.commPrefsKeys !== undefined && this.props.commPrefsKeys !== null) {
      if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
        this.props.communicationValue.forEach((value) => {
          let updateValue = {
            PersonCommPrefId: value.PersonCommPrefId,
            PersonId: value.PersonId,
            CommunicationPreferenceId: value.CommunicationPreferenceId,
            CommunicationPreferenceName: value.CommunicationPreferenceName,
            CreatedBy: value.CreatedBy,
            LastUpdatedBy: value.LastUpdatedBy,
            SourceSystem: value.SourceSystem,
            SourcePersonId: value.SourcePersonId,
            IsDeleted: false
          };
          updateCommPrefs.push(updateValue);
        });
        this.setState({
          CommPreference: updateCommPrefs
        }, () => {
          this.updateCommPreferences(this.state.CommPreference);
        });
      }
    }
  }

  componentDidUpdate(prevProps) {

    if (this.props.prefval !== null && this.props.prefval !== undefined && prevProps.prefval !== this.props.prefval) {
      let prefvaid = this.props.prefval.split('&')[1];
      const commPref = this.state.CommPreference;
      const masterData = this.props.commPrefsKeys.filter((val) => val.CommunicationPreferenceId.toString() === prefvaid);
      if (this.props.prefval.includes('No')) {
        this.IsCommValueChanged(true);
        this.props.setIsCommValueChanged(true);
        const index = commPref.findIndex(m => m.CommunicationPreferenceId == prefvaid);
        let existflag = [];
        for (var i = 0; i < commPref.length; i++) {
          if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
            let originalValue = this.props.communicationValue;
            existflag = originalValue.filter(value => {
              return value.CommunicationPreferenceId == commPref[i].CommunicationPreferenceId;
            });
          }
          if (prefvaid === CommunicationPref.NoThanks || prefvaid === CommunicationPref.DocumentsInBraille || prefvaid === CommunicationPref.DocumentsInLargePrint || prefvaid === CommunicationPref.Audio || prefvaid === CommunicationPref.Dyslexic) {
            if (commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.NoThanks || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.DocumentsInBraille || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.DocumentsInLargePrint || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.Audio || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.Dyslexic) {
              if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0) {
                //Add or delete from existing preference
                //commPref[i].IsDeleted = true;
              }
              else  if (commPref[i].CommunicationPreferenceId.toString() === prefvaid){
                commPref.splice(i, 1)
              }
            }
          }
          else if (prefvaid === CommunicationPref.SignLanguageService || prefvaid === CommunicationPref.RelayUK) {
            if (commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.SignLanguageService || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.RelayUK) {
              if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0 && commPref[i].CommunicationPreferenceId.toString() === prefvaid) {
                //Add or delete from existing preference
                commPref[i].IsDeleted = true;
              }
              else if (commPref[i].CommunicationPreferenceId.toString() === prefvaid) {
                commPref.splice(i, 1)
              }
            }
          }
        }
        this.setState({
          CommPreference: commPref
        });
        this.props.setCommValue(commPref);
        this.updateCommPreferences(this.state.CommPreference);
        this.setState({
          optionValue: false, PrefSecValue: false
        });
      }
      else {
        //New entry(No -> yes)
        let newValue;
        const idx = commPref.findIndex(m => m.CommunicationPreferenceId == prefvaid);
        
          let existflag = [];
          for (var i = 0; i < commPref.length; i++) {
            if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
              let originalValue = this.props.communicationValue;
              existflag = originalValue.filter(value => {
                return value.CommunicationPreferenceId == commPref[i].CommunicationPreferenceId;
              });
            }
            if (prefvaid === CommunicationPref.NoThanks || prefvaid === CommunicationPref.DocumentsInBraille || prefvaid === CommunicationPref.DocumentsInLargePrint || prefvaid === CommunicationPref.Audio || prefvaid === CommunicationPref.Dyslexic) {
              if (commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.NoThanks || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.DocumentsInBraille || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.DocumentsInLargePrint || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.Audio || commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.Dyslexic) {
                if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0 && commPref[i].IsDeleted === false) {
                  //Add or delete from existing preference
                  commPref[i].IsDeleted = true;
                }
                else if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0 && commPref[i].IsDeleted === true && commPref[i].CommunicationPreferenceId.toString() === prefvaid) {
                  commPref[i].IsDeleted = false;
                }
                else if (commPref[i].IsDeleted === false) {
                  commPref.splice(i, 1)
                }
              }
            }
            else if (prefvaid === CommunicationPref.SignLanguageService) {
              if (commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.SignLanguageService) {

              if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0 && commPref[i].IsDeleted === false) {
                //Add or delete from existing preference
                commPref[i].IsDeleted = true;
              }
              else if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0 && commPref[i].IsDeleted === true) 
                {
                  commPref[i].IsDeleted = false;
                }
              }
            }
            else if (prefvaid === CommunicationPref.RelayUK) {
              if (commPref[i].CommunicationPreferenceId.toString() === CommunicationPref.RelayUK) {
              if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0 && commPref[i].IsDeleted === false) {
                //Add or delete from existing preference
                commPref[i].IsDeleted = true;
              }
              else if (existflag.length !== 0 && commPref[i].PersonCommPrefId !== 0 && commPref[i].IsDeleted === true) 
                {
                  commPref[i].IsDeleted = false;
                }
              }
            }
            }
          this.setState({
            CommPreference: commPref
          });
          this.props.setCommValue(commPref);
          this.updateCommPreferences(this.state.CommPreference);
          if (idx !== -1) {
        }
        else {
          if (this.props.communicationValue !== null) {
            newValue = {
              PersonCommPrefId: 0,
              PersonId: this.state.CommPreference[0].PersonId,
              CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
              CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
              CreatedBy: this.props.MemberName,
              LastUpdatedBy: this.props.MemberName,
              SourceSystem: this.state.CommPreference[0].SourceSystem,
              SourcePersonId: this.state.CommPreference[0].SourcePersonId,
              IsDeleted: false
            };
          }
          else {
            newValue = {
              PersonCommPrefId: 0,
              PersonId: "",
              CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
              CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
              CreatedBy: this.props.MemberName,
              LastUpdatedBy: this.props.MemberName,
              SourceSystem: "",
              SourcePersonId: "",
              IsDeleted: false
            };
          }
          const newArrayVal = this.state.CommPreference;
          newArrayVal.push(newValue);
          this.setState({
            CommPreference: newArrayVal
          });
          this.props.setCommValue(newArrayVal);
          this.updateCommPreferences(this.state.CommPreference);
        }

      }
    }

    if (JSON.stringify(prevProps.communicationValue) !== JSON.stringify(this.props.communicationValue)) {
      this.updatedValue(this.props.communicationValue);
    }
  }

  updatedValue(communicationValue) {
    if (communicationValue !== null) {
      this.setState({
        CommPreference: communicationValue,
      });
    }
    else {
      this.setState({
        CommPreference: [],
      });
    }

  }


  PreferenceChanges(event, CommunicationPreferenceId) {
    if (event.target.value === 'No') {
      this.props.setvalueCofirm('No' + '&' + CommunicationPreferenceId);
    }
    else {
      this.props.setvalueCofirm('No' + '&' + CommunicationPreferenceId);
    }
    this.IsCommValueChanged(true);
    this.props.setIsCommValueChanged(true);
    const commPref = this.state.CommPreference;
    const index = commPref.findIndex(m => m.CommunicationPreferenceId === CommunicationPreferenceId);
    const masterData = this.props.commPrefsKeys.filter((val) => val.CommunicationPreferenceId === CommunicationPreferenceId);
    if (index !== -1) {
      let existflag = [];
      if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
        let originalValue = this.props.communicationValue;
        existflag = originalValue.filter(value => {
          return value.CommunicationPreferenceId === commPref[index].CommunicationPreferenceId;
        });
      }
      if (existflag.length !== 0 && commPref[index].PersonCommPrefId !== 0) {
        //Add or delete from existing preference
        commPref[index].IsDeleted = event.target.value === "Yes" ? true : false;
      }
      else {
        // delete entry from existing array(No->yes->No)
        //commPref.splice(index, 1);

      }


      this.setState({
        CommPreference: commPref
      });
      this.setState({
        optionValue: true
      });
    }
    else {
      //New entry(No -> yes)
      let newValue;
      if (this.props.communicationValue !== null) {
        newValue = {
          PersonCommPrefId: 0,
          PersonId: this.state.CommPreference[0].PersonId,
          CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
          CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
          CreatedBy: this.props.MemberName,
          LastUpdatedBy: this.props.MemberName,
          SourceSystem: this.state.CommPreference[0].SourceSystem,
          SourcePersonId: this.state.CommPreference[0].SourcePersonId,
          IsDeleted: false
        };
      }
      else {
        newValue = {
          PersonCommPrefId: 0,
          PersonId: "",
          CommunicationPreferenceId: masterData[0].CommunicationPreferenceId,
          CommunicationPreferenceName: masterData[0].CommunicationPreferenceName,
          CreatedBy: this.props.MemberName,
          LastUpdatedBy: this.props.MemberName,
          SourceSystem: "",
          SourcePersonId: "",
          IsDeleted: false
        };
      }
      const newArrayVal = this.state.CommPreference;
      newArrayVal.push(newValue);
      this.setState({
        CommPreference: newArrayVal
      });
    }
    this.updateCommPreferences(this.state.CommPreference);
  }

  updateCommPreferences(CommPreference) {
    this.props.updateCommPreferences(CommPreference);
  }

  IsCommValueChanged(value) {
    this.props.setIsCommValueChanged(value);
  }

    poupconfirmation(val){
  }

  render() {
    if (this.props.commPrefsKeys !== undefined && this.props.commPrefsKeys !== null) {
      return this.props.commPrefsKeys.length > 0 && this.props.commPrefsKeys.map((informMethod, index) => {
        if (informMethod.CommunicationPreferenceId === 4 || informMethod.CommunicationPreferenceId === 7) {
          let communicationOptionValue = false;
          let Descriptionsss = null;
          let CommDescription = null;
          let NewLabel = null;
          // console.log('this.props.commPrefsKeys'+this.props.commPrefsKeys);
          let CommConfirmation = Store.MyProfileCommunicationNeeds.OnboadingConfirmation;
          if (this.props.communicationValue !== null && this.props.communicationValue !== undefined) {
            communicationOptionValue = this.props.communicationValue.some(val => val.CommunicationPreferenceId === informMethod.CommunicationPreferenceId);
          }
          if (this.state.CommPreference.length !== 0) {
            communicationOptionValue = this.state.CommPreference.some(val => val.CommunicationPreferenceId === informMethod.CommunicationPreferenceId);
          }
          if (informMethod.CommunicationPreferenceId === 4) {
            NewLabel = informMethod.CommunicationPreferenceName;
            Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.SignLanguageService;
            CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.SignLanguageService;
          }
          if (informMethod.CommunicationPreferenceId === 7) {
            NewLabel = informMethod.CommunicationPreferenceName;
            Descriptionsss = Store.MyProfileCommunicationNeeds.OnboadingHeading.RelayUK;
            CommDescription = Store.MyProfileCommunicationNeeds.OnboadingDescription.RelayUK;
          }
          return (
            this.props.mfa ? 
            <FormGroupNeedsMFA
              className={"form-group mt-0"}
              type="yesno"
              id={"comm" + informMethod.CommunicationPreferenceName}
              commId={informMethod.CommunicationPreferenceId.toString()}
              label={NewLabel}
              key={informMethod.CommunicationPreferenceName}
              description={Descriptionsss}
              currentValue={communicationOptionValue}
              Layout={this.props.Layout}
              poupconfirmation={this.props.prefval !== null &&
                informMethod.CommunicationPreferenceId === this.props.prefval.split('&')[1] && this.props.prefval.includes('No') ? false : true}
              onChange={(event) => {
                this.PreferenceChanges(event, informMethod.CommunicationPreferenceId);
                return event.target.value === 'Yes'
                  ? true
                  : event.target.value === 'No'
                    ? false
                    : null;
              }
              }
              SelectionOption={this.props.SelectionOption}
              PrefSecValue={this.state.PrefSecValue}
              Zebrafied={this.props.Zebrafied}
              UseSlider={this.props.UseSlider}
              CommDescription={CommDescription}
              CommConfirmation={CommConfirmation}
              poupconfirmations={(val)=>this.poupconfirmation(val)}
            />:
            <FormGroupNeeds
              className={"form-group mt-0"}
              type="yesno"
              id={"comm" + informMethod.CommunicationPreferenceName}
              commId={informMethod.CommunicationPreferenceId.toString()}
              label={NewLabel}
              key={informMethod.CommunicationPreferenceName}
              description={Descriptionsss}
              currentValue={communicationOptionValue}
              Layout={this.props.Layout}
              poupconfirmation={this.props.prefval !== null &&
                informMethod.CommunicationPreferenceId === this.props.prefval.split('&')[1] && this.props.prefval.includes('No') ? false : true}
              onChange={(event) => {
                this.PreferenceChanges(event, informMethod.CommunicationPreferenceId);
                return event.target.value === 'Yes'
                  ? true
                  : event.target.value === 'No'
                    ? false
                    : null;
              }
              }
              SelectionOption={this.props.SelectionOption}
              PrefSecValue={this.state.PrefSecValue}
              Zebrafied={this.props.Zebrafied}
              UseSlider={this.props.UseSlider}
              CommDescription={CommDescription}
              CommConfirmation={CommConfirmation}
              poupconfirmations={(val)=>this.poupconfirmation(val)}
            />
          );
        }
      });
    }
    return null;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetCommunicationPreference);